@let isRoot = record?.$meta?.isRootRecord;
@let active = isActive();
@let hasChildren = isParent();
@let hasIcon = !!record?.prefixIcon;
@let isChildLevel = !isRoot;

@if (isMobile) {
  @let rowClasses =
    isChildLevel
      ? 'flex  w-full items-center justify-between bg-[#1E63F0] py-4 px-6 text-white font-normal'
      : 'flex  w-full items-center justify-between p-4 text-white';

  @let labelClasses =
    isChildLevel
      ? 'text-[14px] font-medium leading-[20px] tracking-[0.2px] text-white'
      : 'text-[15px] font-medium leading-[20px] tracking-[0.2px] text-white';

  @if (hasChildren) {
    <button
      type="button"
      [class]="rowClasses + ' text-left'"
      (click)="mobileNavigate.emit(record)"
    >
      <span class="flex min-w-0 items-center gap-5">
        @if (isRoot && hasIcon) {
          @if (record.isSvg || record.prefixIcon === 'user-cb') {
            @let iconPath = 'assets/images/icons/' + record.prefixIcon + '.svg';
            <img
              [alt]="record.label + ' icon'"
              [src]="iconPath"
              class="block h-7 w-7 shrink-0 object-contain"
            />
          } @else {
            <mat-icon class="!mr-0 !h-7 !w-7 !text-[28px] !text-white">
              {{ record.prefixIcon }}
            </mat-icon>
          }
        }

        <span [class]="labelClasses">
          {{ record.label }}
        </span>
      </span>

      @if (isRoot) {
        <mat-icon class="!ml-4 !text-[28px] !text-white">
          chevron_right
        </mat-icon>
      }
    </button>
  } @else {
    <a
      [class]="rowClasses + ' no-underline'"
      [routerLink]="routePath()"
      [queryParams]="routePath() ? record['params'] : null"
      [attr.aria-label]="record.ariaLabel"
      (click)="onClick($event)"
    >
      <span class="flex min-w-0 cursor-pointer items-center gap-5">
        @if (isRoot && hasIcon) {
          @if (record.isSvg || record.prefixIcon === 'user-cb') {
            @let iconPath = 'assets/images/icons/' + record.prefixIcon + '.svg';
            <img
              [alt]="record.label + ' icon'"
              [src]="iconPath"
              class="block h-7 w-7 shrink-0 object-contain"
            />
          } @else {
            <mat-icon class="!mr-0 !h-7 !w-7 !text-[28px] !text-white">
              {{ record.prefixIcon }}
            </mat-icon>
          }
        }

        <span [class]="labelClasses">
          {{ record.label }}
        </span>
      </span>
    </a>
  }
}

@if (!isMobile) {
  <mat-menu #childMenu="matMenu" xPosition="after">
    <ul>
      @for (child of record['children']; track child.label) {
        <li
          [appNavigationRecord]="child"
          [isMobile]="false"
          (navigationRecordAction)="navigationRecordAction.emit($event)"
        ></li>
      }
    </ul>
  </mat-menu>

  @let isChildLevel = !isRoot;

  @let baseNavClasses = 'm-0 flex p-0 font-montserrat transition-all';

  @let childNavClasses =
    'h-[46px] w-full items-center border-l-[6px] border-white text-[14px] font-medium leading-[14px] hover:text-[#1471DA] after:absolute after:left-0 after:top-0 after:h-full after:w-[6px] hover:after:bg-[#1471DA]';

  @let rootNavClasses =
    'relative text-[16px] font-semibold uppercase leading-[16px] tracking-normal text-white hover:after:absolute hover:after:-bottom-1 hover:after:left-0 hover:after:h-[3px] hover:after:w-full hover:after:bg-[#2572FF]';

  @let activeChildClasses =
    active && isChildLevel ? 'text-[#2572FF] after:bg-[#2572FF]' : '';

  @let activeRootClasses =
    active && isRoot
      ? 'after:absolute after:-bottom-1 after:left-0 after:h-[3px] after:w-full after:bg-[#2572FF]'
      : '';

  @if (iconOnly) {
    <a
      mat-menu-item
      [matMenuTriggerFor]="hasChildren ? childMenu : null"
      (click)="onClick($event)"
      routerLinkActive="active"
      [attr.aria-label]="record.ariaLabel"
      [routerLinkActiveOptions]="{ exact: true }"
      [routerLink]="routePath()"
      [queryParams]="routePath() ? record['params'] : null"
    >
      <div class="justify-center rounded-full bg-white p-2 text-blue-600">
        @let iconPath = 'assets/images/icons/' + record.prefixIcon + '.svg';
        <img
          [alt]="record.label + ' icon'"
          [src]="iconPath"
          class="block h-[18px] w-[18px]"
        />
      </div>
    </a>
  } @else {
    <a
      mat-menu-item
      [matMenuTriggerFor]="hasChildren ? childMenu : null"
      (click)="onClick($event)"
      routerLinkActive="active"
      [attr.aria-label]="record.ariaLabel"
      [routerLinkActiveOptions]="{ exact: true }"
      [routerLink]="routePath()"
      [queryParams]="routePath() ? record['params'] : null"
    >
      <div
        [ngClass]="[
          baseNavClasses,
          isChildLevel ? childNavClasses : rootNavClasses,
          activeChildClasses,
          activeRootClasses,
        ]"
      >
        @if (record.prefixIcon) {
          @if (!isRoot) {
            <mat-icon
              class="!text-lg !text-[#112F64]"
              [ngClass]="record.label ? '!mr-1' : '!mr-0'"
            >
              {{ record.prefixIcon }}
            </mat-icon>
          }
        }
        {{ record.label }}
      </div>
    </a>
  }
}
